import React, { Component } from "react";
import "../../../Containers/App.css";

import BlogListingPage from "../BlogListingPage";
import Footer from "../../Footer/Footer";
import axios from "axios";
import { withRouter } from "react-router";

import { Container, Col, Row } from "react-bootstrap";

class BlogListingPageContainer extends Component {
  state = { blogs: [] };

  componentDidMount() {
    
    axios
      .get("https://api.shopmuthu.com/blog/")
      .then((response) => {
        console.log(response);
        this.setState({ blogs: response.data });
      });
  }

  toggleProduct = () => {
    const doesShow = this.state.showProduct;
    this.setState({ showProduct: !doesShow });
  };

  showProductDisplayPage = () => {};

  render() {
    let blog = null;

    // if(this.state.showProduct){
    //this.fetchProducts();
    
    blog = (
      <Row>
        {this.state.blogs.map((blog, index) => {
          return (
            <BlogListingPage
              click={() => this.showProductDisplayPage(index)}
              blog={blog}
              key={blog.blogName}
            />
          );
        })}
      </Row>
    );
    //}

    return (
      <Container>
        <Row>
          <Col className="col-md-12">
            <nav>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="/">Home</a>
                </li>

                
              </ol>
            </nav>
          </Col>
        </Row>

        {blog}

        <Footer />
      </Container>
    );
  }
}

export default withRouter(BlogListingPageContainer);
